import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ResourceAllocationsAgentBulkAssignmentTableComponent implements IController {

  queryString: string;
  branchIds: string[];
  agentType: string;
  onAssign: Function;

  public loadLimit: number;
  public agentsRef: any;
  public infiniteScroll: any;

  constructor(private $agents, private $infiniteScroll) {
  }

  $onInit() {

    this.loadLimit = 20;
    this.agentsRef = this.$agents();

    this.agentsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.queryString && !changes.queryString.isFirstChange() ||
      changes.branchIds && !changes.branchIds.isFirstChange() ||
      changes.agentType && !changes.agentType.isFirstChange()) {
      this._query();
    }
  }

  private _getQueryPayload() {
    return {
      branchIds: this.branchIds,
      agentTypes: [this.agentType],
      query: this.queryString,
      limit: this.loadLimit,
    };
  }

  private _query() {
    this.agentsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationsAgentBulkAssignmentTable', {
    bindings: {
      queryString: '<?',
      branchIds: '<?',
      agentType: '<?',
      onAssign: '&'
    },
    template: require('./resource-allocations-agent-bulk-assignment-table.html').default,
    controller: ResourceAllocationsAgentBulkAssignmentTableComponent
  });
